import { Model } from "@vuex-orm/core";
import Licence from "./Licence";

export default class Agency extends Model {
  static get entity() {
    return "agencies";
  }
  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      slug: this.attr(null),
      email: this.attr(null),
      phone: this.attr(null),
      status: this.attr(null),
      owner_id: this.attr(null),
      user_id: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null),
      siren: this.attr(null),
      payment_document: this.attr(null),
      signed_date: this.attr(null),
      licences: this.hasMany(Licence, "agency_id"),
    };
  }
}
